export default __webpack_public_path__ + "static/media/bill-splitter.12e5e917.webp";